const LOCAL_URL = "http://localhost:3001";
const PROD_URL = "https://web-api.chauwk.com";

// Set to true to use local backend, false for production
const USE_LOCAL = false;

export const BASE_URL = USE_LOCAL ? LOCAL_URL : (process.env.REACT_APP_API_BASE || PROD_URL);

export const ENDPOINTS = {
  SEND_EMAIL: `${BASE_URL}/api/website/send`,
};
